import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Container, Row, Col, Button, Nav, Navbar } from "react-bootstrap";

import Menu from "../assets/images/icons/list.png";

import GamesSearchModal from "../views/components/GamesSearchModal";

import { getNotifications } from "../redux/app/actions";

import { APK_LS_KEY, APP_CONST } from "../config/const";
import ModalWrapper from "./ModalWrapper";
import { AiOutlineClose } from "react-icons/ai";
import DownloadApk from "../assets/images/icons/apk-download.svg";

const Header = () => {
  const { appDetails } = useSelector((state) => state.app);
  const [showLeftbarToggle, setShowLeftbarToggle] = useState(false);

  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState("login");
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const isApkEnv = localStorage.getItem(APK_LS_KEY) === "true";

  const handleToggleClick = () => {
    const realTimeValue = !showLeftbarToggle;
    if (realTimeValue) {
      document.body.classList.add("leftbat-opened");
    } else {
      document.body.classList.remove("leftbat-opened");
    }
    setShowLeftbarToggle(realTimeValue);
  };

  const handleModalShow = (modalName) => {
    setShowAuthModals(true);
    setDefaultModal(modalName);
  };

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header
        className={
          scroll
            ? "main-header scrolled header beforeheader"
            : "main-header header beforeheader"
        }
      >
        <Container fluid>
          <Row>
            <Col xs={12}>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div className="leftbar_toggle d-md-block d-none">
                    <Button
                      variant="primary"
                      onClick={() => handleToggleClick()}
                    >
                      <img loading="lazy" src={Menu} />
                    </Button>
                  </div>
                  <div className="logo">
                    <a href="/">
                      <img
                        src={appDetails?.LOGO_URL}
                        alt="Logo"
                        width={66}
                        height={55}
                      />
                      {/* <img loading="lazy"src={logo} alt="Logo" /> */}
                    </a>
                  </div>
                </div>

                <div className="headerRight">
                  {!isApkEnv ? (
                    <div className="dpk-dwnld">
                      <a
                        href="https://dl.dropbox.com/scl/fi/e30366c7sgqtc16mdfndz/xxexch.apk?rlkey=1dv579b0el41s06xadvhrr75w&st=ulqracit&dl=0"
                        download="https://dl.dropbox.com/scl/fi/e30366c7sgqtc16mdfndz/xxexch.apk?rlkey=1dv579b0el41s06xadvhrr75w&st=ulqracit&dl=0"
                      >
                        <img
                          loading="lazy"
                          src={DownloadApk}
                          alt="download apk"
                        />
                        <span>APK</span>
                      </a>
                    </div>
                  ) : null}

                  <div className="me-md-2">
                    <GamesSearchModal />
                  </div>

                  <Button
                    variant="primary"
                    onClick={() => {
                      handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                    }}
                    className="button-primary btn_signin"
                  >
                    Sign in
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
                    }}
                    className="button-primary btn_signup btn-secondary mx-2"
                  >
                    Register
                  </Button>

                  {/* <ul className="chatnlanguage">
                  <li>
                    <a href="javascript:void(0)">
                      <img loading="lazy"src={ChatIcon} />
                    </a>
                  </li>
                  {/* <li>
                    <a href="javascript:void(0)">
                      <img loading="lazy"src={LanguageIcon} />
                    </a>
                  </li>
                </ul> */}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        {showAuthModals && (
          <ModalWrapper
            defaultShow={defaultModal}
            setShowAuthModals={setShowAuthModals}
          />
        )}
      </header>
    </>
  );
};

export default Header;
